import { createSelector } from 'reselect';
import { AssetError, OnClearError } from 'store/error/types';
import { State } from 'store/types';

type ErrorState = State['error']; // Omit<Partial<State>, 'error'> & Pick<State, 'error'>;

const selectState = (state: State): ErrorState => state.error;

export const selectIsNotAuthorized = createSelector(
  selectState,
  (error): boolean => error.isNotAuthenticated,
);

export const selectHasAssetErrors = createSelector(
  selectState,
  (error): boolean => !!error.asset_errors,
);

export const selectAssetErrors = createSelector(
  selectState,
  (error): Record<string, AssetError> | undefined => error.asset_errors,
);

export const selectErrors = createSelector(
  selectState,
  (error) => error.errors,
);

export const selectHasErrors = createSelector(
  selectState,
  (error): boolean => !!error.errors.length,
);

export const selectErrorOnClear = createSelector(
  selectState,
  (error): OnClearError | undefined => error.onClear,
);
